
import React from "react";

const TRAINING_VIDEO_URL =
"https://xwbe3caicn5twuob.public.blob.vercel-storage.com/TapToTable_Client_Dashboard_Training.mp4";

export default function Training() {
  return (
    <main className="min-h-screen bg-[#09090B] px-4 py-10 text-white sm:px-6">
      <div className="mx-auto max-w-5xl">
        <header className="mb-8 text-center">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-cyan-400 text-4xl font-black text-black">
            T
          </div>

          <p className="text-xs font-bold uppercase tracking-[0.2em] text-cyan-400">
            TapToTable Training
          </p>

          <h1 className="mt-3 text-3xl font-bold sm:text-4xl">
            Client Dashboard Walkthrough
          </h1>

          <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">
            Learn how to manage your restaurant page, create
            promotions and events, customize your settings,
            and share your TapToTable link with customers.
          </p>
        </header>

        <section className="overflow-hidden rounded-2xl border border-cyan-400/30 bg-black shadow-xl">
          <video
            controls
            playsInline
            preload="metadata"
            className="aspect-video w-full bg-black"
          >
            <source src={TRAINING_VIDEO_URL} type="video/mp4" />
            Your browser does not support HTML5 video.
          </video>
        </section>

        <div className="mt-5 flex flex-wrap items-center justify-between gap-3 text-sm text-zinc-400">
          <span>Complete walkthrough · Approximately 9 minutes</span>
          <span>Watch on your phone or computer</span>
        </div>

        <section className="mt-10 rounded-xl border border-zinc-800 bg-zinc-900/50 p-6">
          <h2 className="text-lg font-semibold">
            What You'll Learn
          </h2>

          <ul className="mt-4 grid gap-3 text-sm text-zinc-300 sm:grid-cols-2">
            <li>✓ Create promotions, events, and featured items</li>
            <li>✓ Customize photos and page colors</li>
            <li>✓ Manage Before Claim and After Claim settings</li>
            <li>✓ Understand visits and claim activity</li>
            <li>✓ Update restaurant information</li>
            <li>✓ Save, preview, and share your page</li>
          </ul>
        </section>

        <footer className="mt-10 text-center text-sm text-zinc-500">
          TapToTable — Turn Followers Into Customers.
        </footer>
      </div>
    </main>
  );
}
